import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/client/components/base/card";

const ScannersPage = () => (
    <div className="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6">
        <h1 className="text-2xl font-semibold tracking-tight">Scanners</h1>
        <p className="mt-1 text-sm text-muted-foreground">
            Screens for opportunities across indices, stocks and derivatives.
        </p>

        <Card className="mt-6">
            <CardHeader>
                <CardTitle>Coming soon</CardTitle>
                <CardDescription>Scanners are under construction.</CardDescription>
            </CardHeader>
            <CardContent>
                <ul className="grid gap-1.5 text-sm text-muted-foreground">
                    <li>All-time-high trending scans</li>
                    <li>Oversold and bullish reversal scans</li>
                    <li>Calendar spread opportunities</li>
                </ul>
            </CardContent>
        </Card>
    </div>
);

export default ScannersPage;
